// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name-capture[data-v-76eb561f]{position:relative;max-width:450px}.person-icon[data-v-76eb561f]{margin:-22px}.profile-photo[data-v-76eb561f]{border-radius:50%}", ""]);
// Exports
module.exports = exports;
